export default "audio/bot_explosion.mp3";